<template>
  <div>
    <el-form :model="formData" size="small" ref="formData" :rules="rules" label-width="100px">
      <el-form-item align="left" label="Crafite Name">{{chooseItem.crafite_name}}</el-form-item>
      <el-input style="display: none" v-model="formData.crafite_uuid"></el-input>
      <el-form-item align="left" prop="language" label="Language">
        <el-select v-model="formData.language">
          <el-option
            key=1
            label="English"
            :value=1>
          </el-option>
          <el-option
            key=2
            label="Spanish"
            :value=2>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item align="left" label="Zip File" prop="file">
        <label style="margin-left:20px;width: 100px;"
               class="float-left btn-block re-upload-img-btn">
          select file
          <input ref="file" accept="application/zip" type="file" @change="setFile()" class="re-upload-img"/>
        </label>
      </el-form-item>
      <el-form-item align="left" v-if="filename!=''">
        {{'filename:'+filename}}
      </el-form-item>
      <el-form-item align="right">
        <el-button @click="$emit('closeUpload',false)">Back</el-button>
        <el-button class="el-button--primary" @click="submit('formData')">Upload</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'CraftiesContentZipUpload',
    props:{
      language: Number,
      chooseItem:Object,
      closeUpload:Function
    },
    data(){
      return{
        formData:{
          crafite_uuid:'',
          language:1,
          file:null,
        },
        rules:{
          file:[{required:true,message:'please select zipFile!'}]
        },
        filename:'',
      }
    },
    created () {
      this.formData.crafite_uuid=this.chooseItem.crafite_uuid
      this.formData.language=this.language
    },
    methods:{
      setFile () {
        this.formData.file = this.$refs['file'].files[0]
        this.filename = this.$refs['file'].files[0].name
        this.$refs['file'].value = ''
        this.$refs['formData'].fields[1].validateMessage = ''
        this.$refs['formData'].fields[1].validateState = 'success'
      },
      submit(formName){
        this.$refs[formName].validate(
          (valid)=>{
            console.log(JSON.stringify(this.formData))
            if(valid){
                let form=new FormData()
                form.append('crafite_uuid',this.formData.crafite_uuid)
                form.append('language',this.formData.language)
                form.append('file',this.formData.file)
               let loading=this.$util.loading()
               this.$api.rootV1.post('/web/playlist/audio/batch/zip',form,(res)=>{
                 this.$alert('Successfully upload!', 'info', {
                   confirmButtonText: 'confirm',
                   type: 'success',
                   callback: action => {
                     loading.close()
                   }
                 })
                 this.$emit('closeUpload',true)
               },(res)=>{
                 this.$alert(`upload failed!${res.errmsg}`, 'info', {
                   confirmButtonText: 'confirm',
                   type: 'error',
                   callback: action => {
                     loading.close()
                   }
                 })
                 this.$emit('closeUpload',false)
               })
            }else {
              this.$message.warning('Please check the input data!')
            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/crafties/CraftiesContentZipUpload.vue